export const formatTime = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  const ms = Number.isFinite(num) ? (num < 1e12 ? num * 1000 : num) : Date.parse(value);
  if (!Number.isFinite(ms)) return String(value);
  try {
    return new Date(ms).toLocaleString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      month: "short",
      day: "numeric",
    });
  } catch {
    return String(value);
  }
};

/** Short time for contact list rows (e.g. 06:40 AM). */
export const formatListTime = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  const ms = Number.isFinite(num) ? (num < 1e12 ? num * 1000 : num) : Date.parse(value);
  if (!Number.isFinite(ms)) return String(value);
  try {
    return new Date(ms).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
};

export const formatMobile = (waid) => {
  if (waid == null) return "";
  const s = String(waid);
  return s.startsWith("+") ? s : `+${s}`;
};

export const messagePreview = (msg) => {
  if (!msg) return "…";
  if (typeof msg === "string") return msg;
  if (typeof msg.body === "string" && msg.body) return msg.body;
  if (typeof msg.content === "string" && msg.content) return msg.content;
  if (typeof msg.message === "string" && msg.message) return msg.message;
  if (msg.message?.text?.body) return msg.message.text.body;
  if (msg.message?.body) return String(msg.message.body);
  if (msg.text?.body) return String(msg.text.body);
  if (msg.message != null) return String(msg.message);
  return msg.type || "Message";
};

export const lastMessagePreview = (contact) => {
  const content = contact?.lastMessage?.content;
  if (!content) return "No messages yet";
  return String(content);
};

export const formatBubbleTime = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  const ms = Number.isFinite(num) ? (num < 1e12 ? num * 1000 : num) : Date.parse(value);
  if (!Number.isFinite(ms)) return "";
  try {
    return new Date(ms).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export const messageDayKey = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  const ms = Number.isFinite(num) ? (num < 1e12 ? num * 1000 : num) : Date.parse(value);
  if (!Number.isFinite(ms)) return "";
  return new Date(ms).toDateString();
};

export const formatDayLabel = (value) => {
  const key = messageDayKey(value);
  if (!key) return "";
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (key === today.toDateString()) return "Today";
  if (key === yesterday.toDateString()) return "Yesterday";
  try {
    return new Date(key).toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return key;
  }
};

export const avatarLetter = (name) =>
  (name || "?").slice(0, 1).toUpperCase();

export const avatarAccent = (name) =>
  name?.toLowerCase().includes("vyapari") ? "pink" : "green";

const AVATAR_TONES = ["green", "teal", "blue", "amber", "rose", "violet"];

export const inboxAvatarTone = (name) => {
  const value = String(name || "");
  if (!value) return "green";
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash += value.charCodeAt(i) * (i + 1);
  }
  return AVATAR_TONES[hash % AVATAR_TONES.length];
};

export const deliveryTick = (status) => {
  const value = String(status || "sent").toLowerCase();
  if (value === "failed") return { label: "Failed", icon: null };
  if (value === "read") return { label: "Read", icon: "double" };
  if (value === "delivered") return { label: "Delivered", icon: "double" };
  return { label: "Sent", icon: "single" };
};

export const messageKey = (msg) => {
  if (!msg) return null;
  return msg._id || msg.id || null;
};

/** Append a message unless the same id is already in the list. */
export const appendUniqueMessage = (messages, msg) => {
  const key = messageKey(msg);
  if (key && messages.some((m) => messageKey(m) === key)) return messages;
  return [...messages, msg];
};
